import { render, staticRenderFns } from "./SlideContent.vue?vue&type=template&id=0da23288"
import script from "./SlideContent.vue?vue&type=script&lang=js"
export * from "./SlideContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports